import { NavBarList } from 'ui/components';

import NavDropdown from './NavDropdown';

import type { ListLinksItemProps } from 'core';

export const NavBarCollapse = ({ data = [], dropdown = false }: ListLinksItemProps) => {
  if (!dropdown) {
    return <></>;
  }

  return (
    <NavBarList.Wrapper className={dropdown ? 'active' : ''} data-testid="nav-bar-collapse">
      <NavBarList.Dropdown>
        {data?.map(({ links: utilLinks = [], title, navColumns = [], component }, index) => {
          const linkLength = utilLinks?.length;

          if (navColumns?.length) {
            return (
              <NavBarList.Columns key={`dropdownlist-${index}`}>
                {navColumns.map(({ links = [], title: titleList }) => {
                  return (
                    <NavDropdown
                      key={`navbarlist-${titleList}`}
                      linkLength={linkLength}
                      links={links}
                      title={titleList}
                    />
                  );
                })}
              </NavBarList.Columns>
            );
          }

          return (
            <NavDropdown
              component={component}
              key={`navbarlist-${index}`}
              linkLength={linkLength}
              links={utilLinks}
              title={title}
            />
          );
        })}
      </NavBarList.Dropdown>
    </NavBarList.Wrapper>
  );
};

export default NavBarCollapse;
